<template>
  <login-component/>
</template>

<script>
import LoginComponent from '@/spa/components/login/LoginComponent';

export default {
  name: 'LoginPage',

  components: {
    LoginComponent,
  },
};

</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/spa/pages/LoginPage.vue